/**
 * Раздел администрирования открыт только для просмотра — на телефоне
 * (docs/08-mobile-roadmap.md, M5).
 *
 * Единственное место, где это решается: страницы складывают признак со
 * своими правами (canEdit && !readOnly), и кнопки изменения исчезают по той
 * же логике, что и при отсутствии права. Это ограничение интерфейса, а не
 * прав: сервер проверяет права как раньше, на планшете и десктопе всё доступно.
 */

import { useIsPhone } from "@/shared/lib/media";

export function useAdminReadOnly(): boolean {
  return useIsPhone();
}
